module.exports = __webpack_public_path__ + "static/35-b7f5979eb76fba26b9d008a78ddb0dc0.png";